/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MonthlyDeliveryNoteReportsList } from '../../models/monthly-delivery-note-reports-list';

export interface ListMonthlyDeliveryNoteReports$Params {
}

export function listMonthlyDeliveryNoteReports(http: HttpClient, rootUrl: string, params?: ListMonthlyDeliveryNoteReports$Params, context?: HttpContext): Observable<StrictHttpResponse<MonthlyDeliveryNoteReportsList>> {
  const rb = new RequestBuilder(rootUrl, listMonthlyDeliveryNoteReports.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MonthlyDeliveryNoteReportsList>;
    })
  );
}

listMonthlyDeliveryNoteReports.PATH = '/administration/delivery-notes/monthly-reports';
